import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RenterRegFormService } from '@accounts/operator/services/renter-reg-form.service';
import { RenterForm } from '@core/components/abstract/renter-form';

@Component({
  selector: 'renter-passport',
  templateUrl: './renter-passport.component.html',
  styleUrls: ['./renter-passport.component.scss']
})
export class RenterPassportComponent extends RenterForm implements OnInit {

  nowDate = new Date();

  constructor(
    private renterFormService: RenterRegFormService
  ) {
    super();
  }

  get form(): FormGroup {
    try {
      return this.renterFormService.renterIdentificationDataForm.get('passport') as FormGroup;
    } catch (e) {
      throw new Error('Renter form was not built');
    }
  }

  ngOnInit() {}

}
